import { render } from "./Product.vue?vue&type=template&id=66bea6e6&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=66bea6e6&lang=scss&scoped=true"
import "./Product.vue?vue&type=style&index=1&id=66bea6e6&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bea6e6"]])

export default __exports__